export default "__VITE_PUBLIC_ASSET__dcbe23aa__"